<template>
    <v-btn v-if="isUserCompany" dark color="red" class="mt-10" @click="close">
        <v-icon class="mr-8"> mdi-phone-cancel </v-icon>
        <span> 종료하기 </span>
    </v-btn>
</template>

<script>
import { mapActions, mapState } from "vuex";
export default {
    computed: {
        ...mapState({
            _user: (state) => state?.payload?._user,
        }),
        ...mapState("interview", {
            interview: "data",
        }),
        isUserCompany() {
            return this._user == this.interview?._company;
        },
    },
    methods: {
        ...mapActions("interview/server", ["close"]),
    },
};
</script>

<style>
</style>